<template>
  <div class="sidepanel-da">
    <EditPollSection
      v-model="displayDates"
      :title="$t('options.sectionDates')"
    />

    <template v-if="displayDates">
      <p class="text-size-14">
        {{ $t('options.sectionDatesDecription') }}
      </p>

      <div class="row justify-content-center">
        <vc-calendar
          :attributes="attributes"
          :min-date="getMinDate"
          :columns="$screens({ default: 1, lg: 2 })"
          :theme-styles="themeStyles"
          @dayclick="onDayClick"
          is-dark
          is-inline
          :locale="locale"
        />
      </div>

      <div v-if="selectedDays.length" class="time-zone text-size-16 pt-3 pb-1">
        {{ $t('options.timeZone') }}
        <span class="text-weight-bold">
          {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
        </span>
      </div>

      <div class="c-wrapper text-center">
        <component
          @add-range="addRange(id)"
          @copy-range="copyRange(id)"
          @remove-range="(range) => removeRange(id, range)"
          @remove-date="(range) => removeDate(id)"
          @update="onUpdate"
          @focus="onFocus"
          @blurr="onBlurr"
          v-for="(option, id) in selectedDays"
          :key="selectedDays[id].key"
          :dayOption="selectedDays[id]"
          v-bind:is="currentTabComponent"
        ></component>
      </div>
    </template>
  </div>
</template>
<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import EditPollSection from '@/components/Edit/EditPollSection.vue';
import OptionTime from '@/components/Create/OptionTime.vue';
import { mapState } from 'vuex';
import { dateMixin } from '@/components/mixins/DateMixins.js';

function hasTime(d) {
  if (d == null) return false;
  let date = new Date(d);
  if (date.getHours() != 0) return true;
  if (date.getMinutes() != 0) return true;
  if (date.getSeconds() != 0) return true;
  return false;
}

function Range(choice) {
  this.date = choice.date;
  this.id = choice.id;
  this.start = choice.start;
  this.end = choice.end;
  this.comment = choice.text;
  this.limit = choice.limit;
}

function DayOptions(date, id, key) {
  date.setHours(0, 0, 0, 0);
  this.date = date;
  this.key = key;
  let choice = {
    id: id,
    date: date,
    start: date,
    end: date,
    text: null,
    limit: 0,
  };
  this.ranges = [new Range(choice)];
}

function createDayOptionWithChoice(date, choice) {
  let obj = {};
  date.setHours(0, 0, 0, 0);
  obj.date = date;
  obj.ranges = [new Range(choice)];
  return obj;
}

function sameDay(d1, d2) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

export default {
  name: 'EditDates',

  props: [],

  mixins: [dateMixin],

  components: {
    SidePanel,
    EditPollSection,
    'app-option-time': OptionTime,
  },

  data() {
    const hSpacing = '15px';

    return {
      displayDates: true,
      key: 0,
      newId: -1,
      localDetails: null,
      backup: null,
      currentTabComponent: 'app-option-time',
      themeStyles: {
        wrapper: {
          background: 'linear-gradient(to bottom right, #ff5050, #ff66b3)',
          color: '#fafafa',
          border: '0',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
          borderRadius: '5px',
        },
        header: {
          padding: `20px ${hSpacing}`,
        },
        headerHorizontalDivider: {
          borderTop: 'solid rgba(255, 255, 255, 0.2) 1px',
          width: '80%',
        },
        weekdays: {
          color: '#6eded1', // New color
          fontWeight: '600', // And bolder font weight
          padding: `20px ${hSpacing} 5px ${hSpacing}`,
        },
        weeks: {
          padding: `0 ${hSpacing} ${hSpacing} ${hSpacing}`,
        },
        dayContent: {
          fontSize: '0.9rem',
        },
      },
      dayOptions: [],
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),

    selectedDays() {
      return this.dayOptions;
    },

    isNewPoll() {
      return this.poll.options.initialised == false;
    },

    locale() {
      return this.$store.getters.userLocale;
    },

    cancelLabel() {
      return null;
      // if (this.isNewPoll) {
      //   return null;
      // }
      // return this.$t('general.cancel');
    },
    saveText() {
      if (this.poll.type == 2) {
        return this.$t('create.dlgSaveDone');
      } else {
        if (this.isNewPoll) {
          return this.$t('create.dlgContinue');
        }
      }
      return this.$t('create.dlgSaveDone');
    },
  },

  watch: {
    dates: {
      deep: true,
      handler: function () {
        this.updateDayOptionsFromDates();
      },
    },
  },

  methods: {
    onFocus() {
      console.log('onFocus: disable scrolling');
      this.$refs.spanel.disableScrolling();
    },
    onBlurr() {
      console.log('onBlurr: enable scrolling');
      this.$refs.spanel.enableScrolling();
    },
    onCancel() {
      console.error('OnCancel - Dates ');
      // if (!this.isNewPoll) {
      //   this.$store.dispatch('updateChoices', this.backup);
      // }
      //this.$store.dispatch('updateChoices', this.backup);
      this.$emit('cancel');
    },
    onSave() {
      console.log(
        'Update poll choices with:',
        this.poll.choices,
        this.isNewPoll
      );

      if (this.isNewPoll) {
        let options = this.poll.options;
        options.initialised = true;
        let participants = this.poll.participants;
        let participant = participants[0];
        participant.isCurrentUser = true;
        //participant.isCurrentUserParticipant = true;
        this.$store.commit('updateParticipant', participant);
        console.log('After updateParticipant:', this.poll.participants);
        this.$store.commit('updateOptions', options);
      }
      this.$store.dispatch('updateChoices', this.poll.choices).then(() => {
        this.$emit('save');
      });
    },

    updateDayOptions(newRange) {
      for (var i = 0; i < this.dayOptions.length; i++) {
        let day = this.dayOptions[i];
        for (let range of day.ranges) {
          {
            if (range.id == newRange.id) {
              console.log('Update range with id:', range.id);
              range = newRange;
              this.$set(this.dayOptions, i, day);
            }
          }
        }
      }
    },

    onUpdate(range) {
      let choiceIndex = this.poll.choices.findIndex(
        (choice) => choice.id == range.id
      );
      //console.info('OpionTime update range:', range, choiceIndex);

      let choice = this.poll.choices[choiceIndex];
      choice.text = range.comment;
      choice.start = range.start;
      choice.end = range.end;
      choice.limit = range.limit;
      this.poll.choices[choiceIndex] = choice;
      this.updateDayOptions(range);
    },

    addRange(index) {
      console.log('event add  range index :', index);
      let date = this.dayOptions[index].date;
      let choice = {
        id: this.newId--,
        start: date,
        end: null,
        text: null,
        limit: null,
      };
      this.dayOptions[index].ranges.push(new Range(choice));

      let choices = this.poll.choices;
      choices.push(choice);
      console.log('addRange:', choices);
      this.$store.commit('updateChoices', choices);
    },

    updateTimeDate(time, newDate) {
      //console.log('updateTimeDate', time, newDate);
      const year = newDate.getFullYear();
      const month = newDate.getMonth();
      const date = newDate.getDate();

      let newTime = new Date(time);
      newTime.setFullYear(year);
      newTime.setMonth(month, 1);
      newTime.setDate(date);
      //console.log('updateTimeDate y-m-d', year, month, date, newTime);
      return newTime;
    },

    // compares the relevant part of start and end
    // timestap format is "2022-01-19T07:00:00.000000Z"
    rangeExistIn(range, ranges) {
      //console.log("Check if range exists:", range.start, range.end);

      let d = new Date(range.start).toISOString();
      const start = d.split('T')[1];

      d = new Date(range.end).toISOString();
      const end = d.split('T')[1];
      for (let i = 0; i < ranges.length; i++) {
        const r = ranges[i];
        if (!r.start || !r.end) continue;

        d = new Date(r.start).toISOString();
        if (start != d.split('T')[1]) continue;

        d = new Date(r.end).toISOString();
        if (end != d.split('T')[1]) continue;

        if (range.comment != r.comment) continue;
        return true;
      }
      return false;
    },

    removeEmptySlots(day) {
      let ranges = this.dayOptions[day].ranges;

      for (var i = 0; i < ranges.length; i++) {
        const range = ranges[i];

        let hasComment = false;
        if (range.comment && range.comment != '-') hasComment = true;

        if (hasTime(range.start) || hasTime(range.end) || hasComment) {
          console.log(' ', range);
          continue;
        }
        const rangeId = range.id;
        ranges.splice(i, 1);
        i--;
        this.$store.commit('removeChoice', rangeId);
      }
    },

    copyFromTo(from, to) {
      const ranges = this.dayOptions[from].ranges;
      console.log(`copy all ranges from day: ${from} to day:${to}`);
      let choices = this.poll.choices;
      for (var i = 0; i < ranges.length; i++) {
        console.log('insert range to', i, ranges[i]);

        const range = ranges[i];

        // check if a valid range
        if (!range.start) continue;
        //
        if (this.rangeExistIn(range, this.dayOptions[to].ranges)) {
          continue;
        }

        const start = this.updateTimeDate(
          range.start,
          this.dayOptions[to].date
        );
        const end = range.end
          ? this.updateTimeDate(range.end, this.dayOptions[to].date)
          : null;
        const limit = range.limit;

        console.info('Insert new range:', start, end, limit);
        let choice = {
          id: this.newId--,
          start: start,
          end: end,
          text: range.comment,
          limit: limit,
        };
        this.dayOptions[to].ranges.push(new Range(choice));
        console.info('Insert new choice:', choice.id, choice.limit);
        choices.push(choice);
        this.$store.commit('updateChoices', choices);
      }
      this.removeEmptySlots(to);
    },

    copyRange(fromDay) {
      console.log(
        'event copy all ranges from day:',
        fromDay,
        this.dayOptions[fromDay]
      );

      for (var index = 0; index < this.dayOptions.length; index++) {
        if (index == fromDay) continue;
        this.copyFromTo(fromDay, index);
      }
    },

    removeRange(index, range) {
      console.log(
        `remove range ${range} from date ${index}`,
        this.dayOptions[index].ranges[range]
      );

      if (this.dayOptions[index].ranges.length == 1) {
        this.removeDate(index);
        return;
      }
      let rangeId = this.dayOptions[index].ranges[range].id;
      this.dayOptions[index].ranges.splice(range, 1);
      this.$store.commit('removeChoice', rangeId);
      console.log('DayOptions:', index, this.dayOptions[index]);
    },

    isInputValid() {
      if (this.title == '') {
        this.titleIsMissing = true;
        return false;
      }
      this.titleIsMissing = false;

      if (this.dates.length == 0) {
        this.datesAreMissing = true;
        return false;
      }
      this.datesAreMissing = false;
      return true;
    },

    notEqual(choice, day) {
      let date1 = new Date(choice.start);
      date1 = date1.toDateString();
      let date2 = new Date(day.date);
      date2 = date2.toDateString();
      console.log('notEual:', date1, date2);
      return date1 != date2;
    },

    updateDayOptionsFromDates() {
      console.log('Update day options from dates:', this.dayOptions);
      this.isInputValid();

      if (this.dates.length == 0) {
        this.dayOptions = [];
        this.poll.choices = [];
        console.info('clear dayOptions');
        return;
      }

      let selectedDates = [...this.dates];
      let toBeRemoved = [];

      for (const dayOption of this.dayOptions) {
        // if the dayOptions date is selected just remove it from the list
        let exist = selectedDates.find((date) => sameDay(date, dayOption.date));
        console.log('date exist in dayOptions:', dayOption.date);
        if (exist) {
          selectedDates = selectedDates.filter(
            (date) => !sameDay(date, dayOption.date)
          );
        } else {
          // if the dayOptions date is not selected anymore -> remove it
          console.log('date do not exist in dayOptions:', dayOption.date);
          toBeRemoved.push(dayOption);
        }
      }
      console.log('removed TBR items:', toBeRemoved);
      for (const item of toBeRemoved) {
        console.log('Remove item:', item);
        this.dayOptions = this.dayOptions.filter((day) => day != item);
        this.poll.choices = this.poll.choices.filter((choice) => {
          if (choice.start == null) return true;
          return this.notEqual(choice, item);
        });
      }

      console.log('Add dayOptions for the new selected date:', selectedDates);
      for (const date of selectedDates) {
        let id = this.newId--;
        this.dayOptions.push(new DayOptions(date, id, this.key++));
        let choice = {
          id: id,
          date: date,
          start: date,
          end: date,
          text: null,
          limit: null,
        };
        this.poll.choices.push(choice);
      }

      this.dayOptions.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });

      this.poll.choices.sort(function (a, b) {
        if (a.start == null || b.start == null) return -1;
        return new Date(a.date) - new Date(b.date);
      });

      console.log('updated lchoice list:', this.poll.choices);
    },

    addDay2DayOptions(day) {
      let id = this.newId--;
      this.dayOptions.push(new DayOptions(day.date, id));
      this.dayOptions.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });

      let choice = {
        id: id,
        date: day.date,
        start: day.date,
        end: day.date,
        text: null,
        limit: null,
      };
      console.log('new choice ==> ', choice);
      this.poll.choices.push(choice);
      this.poll.choices.sort(function (a, b) {
        return new Date(a.start) - new Date(b.start);
      });
    },

    removeDateFromOptions(date) {
      console.log('removeDayFromOptions day:', date);
      const idx = this.dayOptions.findIndex((o) => {
        return o.date.toDateString() == date.toDateString();
      });
      console.log('removeDayFromOptions index:', idx);
      const tbrItem = this.dayOptions[idx];
      this.poll.choices = this.poll.choices.filter((choice) => {
        if (choice.start == null) return true;
        return this.notEqual(choice, tbrItem);
      });
      this.dayOptions.splice(idx, 1);
    },

    removeDate(id) {
      //this.dates.splice(id, 1);
      console.log('removeDate:', id);
      // remove the date from days
      const option = this.dayOptions[id];
      const idx = this.days.findIndex(
        (d) => d.date.toDateString() == option.date.toDateString()
      );
      if (idx >= 0) {
        this.removeDateFromOptions(this.days[idx].date);
        this.days.splice(idx, 1);
      }
    },

    onDayClick(day) {
      const id = day.date.toISOString().split('T')[0];
      const idx = this.days.findIndex((d) => d.id === id);
      if (idx >= 0) {
        //        const day2Remove = this.days[idx];
        this.removeDateFromOptions(day.date);

        this.days.splice(idx, 1);
      } else {
        this.days.push({
          id: id,
          date: day.date,
        });

        this.addDay2DayOptions(day);
      }
    },

    updateDayOptionsFromChoices(choices) {
      for (const choice of choices) {
        if (choice.start == null) continue;
        let date = new Date(choice.start);
        date.setHours(0, 0, 0, 0);
        let exist = this.dates.find((item) => sameDay(item, date));
        if (exist) {
          continue;
        }

        let day = date.toISOString().split('T')[0];
        console.log('updateDayOptionsFromChoices add', date, day);
        this.dates.push(date);

        this.days.push({
          id: day,
          date: date,
        });
      }

      let dayOptions = [];
      for (const choice of choices) {
        let date = new Date();
        if (choice.start) {
          date = new Date(choice.start);
        }
        date.setHours(0, 0, 0, 0);

        // add the choice into the right day widget
        // console.log('Check for date:', date);
        let option = dayOptions.find((item) => {
          return sameDay(item.date, date);
        });
        if (option == null) {
          option = createDayOptionWithChoice(date, choice);
          dayOptions.push(option);
        } else {
          let range = new Range(choice);
          option.ranges.push(range);
        }
      }
      this.dayOptions = dayOptions;
      return;
    },
  },

  mounted() {
    let choices = this.poll.choices;
    //this.backup = JSON.parse(JSON.stringify(choices));
    this.updateDayOptionsFromChoices(choices);
    // TODO:
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';

.c-wrapper {
  margin-top: 8px;
  padding-bottom: 10px;
}
</style>
